export type DatePreset = "thisMonth" | "lastMonth" | "last30" | "last90" | "ytd" | "all" | "custom";

export const DATE_PRESETS: { key: DatePreset; label: string }[] = [
  { key: "thisMonth", label: "This month" },
  { key: "lastMonth", label: "Last month" },
  { key: "last30", label: "Last 30 days" },
  { key: "last90", label: "Last 90 days" },
  { key: "ytd", label: "Year to date" },
  { key: "all", label: "All time" },
  { key: "custom", label: "Custom" },
];

export interface DateRange {
  start: string;
  end: string;
}

// Payout months run on UTC, so report dates do too.
export const utcDate = (y: number, m: number, d: number) =>
  new Date(Date.UTC(y, m, d)).toISOString().slice(0, 10);

export const addDays = (date: string, n: number) => {
  const [y, m, d] = date.split("-").map(Number);
  return utcDate(y, m - 1, d + n);
};

// Returns an inclusive [start, end] range of UTC calendar dates.
export const presetRange = (preset: DatePreset): DateRange | null => {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const today = utcDate(y, m, now.getUTCDate());
  switch (preset) {
    case "thisMonth":
      return { start: utcDate(y, m, 1), end: today };
    case "lastMonth":
      return { start: utcDate(y, m - 1, 1), end: utcDate(y, m, 0) };
    case "last30":
      return { start: addDays(today, -29), end: today };
    case "last90":
      return { start: addDays(today, -89), end: today };
    case "ytd":
      return { start: utcDate(y, 0, 1), end: today };
    default:
      return null;
  }
};

export const formatRangeDate = (date: string) =>
  new Date(`${date}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });

export const csvCell = (v: string | number | boolean | null | undefined) =>
  `"${String(v ?? "").replace(/"/g, '""')}"`;

export const downloadCsv = (rows: (string | number | boolean | null | undefined)[][], filename: string) => {
  const blob = new Blob([rows.map((r) => r.map(csvCell).join(",")).join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.replace(/[\\/:*?"<>|]/g, "-");
  a.click();
  URL.revokeObjectURL(url);
};
